export enum filtersConsts {
  STATUS = 1,
  LABELS = 2,
  MILESTONES = 3,
  PROJECTS = 4,
  FILTER_CHECKBOX_TYPE = 'checkbox',
  FILTER_SELECT_TYPE = 'select',
}
